import React from "react";
import { useNavigate } from "react-router-dom";
import { USERS_ROUTE } from "../../../routes";
import { DATA_LIST_PAGE_SIZE } from "../../../settings";
import { UsersList } from "../../Widgets/UsersList/UsersList";
import { Breadcrumbs } from "../../Widgets/Breadcrumbs/Breadcrumbs";
import { ListItemContextMenu, openInNewTab, useListContextMenu } from "../../Widgets/ListItemContextMenu/ListItemContextMenu";

function Users() {
    const history = useNavigate();
    const {menuProps, anchorPoint, targetId, onContextMenu, close} = useListContextMenu();
    const userPath = (id: string) => `${USERS_ROUTE}/${id}`;
    const userClickHandler = (id: string) => {
        history(userPath(id));
    };
    const openClickHandler = () => {
        if (targetId) {
            userClickHandler(targetId);
        }
    };
    const openInNewTabClickHandler = () => {
        if (targetId) {
            openInNewTab(userPath(targetId));
        }
    };
    return (
        <div>
            <Breadcrumbs />
            <UsersList tag="list_users" pageSize={DATA_LIST_PAGE_SIZE} userClickHandler={userClickHandler} contextMenuHandler={onContextMenu} />
            <ListItemContextMenu menuProps={menuProps} anchorPoint={anchorPoint}
                                 onClose={close} onOpen={openClickHandler} onOpenInNewTab={openInNewTabClickHandler}/>
        </div>
    );
}

export default Users;
